var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCopy = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.613,
    height: 25.571,
    viewBox: "0 0 21.613 25.571",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archivo_3_",
    "data-name": "archivo (3)",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M60.192,3.349H58.06V1.218A1.221,1.221,0,0,0,56.843,0H41.315A1.221,1.221,0,0,0,40.1,1.218V20.7a1.221,1.221,0,0,0,1.218,1.218h2.131v2.131a1.221,1.221,0,0,0,1.218,1.218H55.015a3.553,3.553,0,0,0,2.1-.835l3.4-3.2a3.234,3.234,0,0,0,.887-2.052V4.567A1.222,1.222,0,0,0,60.192,3.349ZM43.446,4.567V21.008H41.315a.309.309,0,0,1-.3-.3V1.218a.309.309,0,0,1,.3-.3H56.843a.309.309,0,0,1,.3.3V3.349H44.664A1.221,1.221,0,0,0,43.446,4.567Zm16.45,16-3.4,3.2a1.616,1.616,0,0,1-.261.191v-2.8a.763.763,0,0,1,.761-.761h3.046A1.278,1.278,0,0,1,59.9,20.569Zm.6-1.387a1.42,1.42,0,0,1-.041.3h-3.46A1.678,1.678,0,0,0,55.32,21.16v3.16a1.592,1.592,0,0,1-.3.037H44.664a.308.308,0,0,1-.3-.3V4.567a.308.308,0,0,1,.3-.3H60.192a.309.309,0,0,1,.3.3Z",
    transform: "translate(-40.097)",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242",
    transform: "translate(7.46 7.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M200.521,154.216h-8.829a.457.457,0,1,0,0,.913h8.829a.457.457,0,1,0,0-.913Z",
    transform: "translate(-191.235 -154.216)",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(7.46 13.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M200.521,277.59h-8.829a.457.457,0,1,0,0,.913h8.829a.457.457,0,1,0,0-.913Z",
    transform: "translate(-191.235 -277.59)",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246",
    transform: "translate(7.46 16.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M196.564,339.277h-4.871a.457.457,0,0,0,0,.913h4.871a.457.457,0,0,0,0-.913Z",
    transform: "translate(-191.236 -339.277)",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248",
    transform: "translate(7.46 10.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M200.521,215.9h-8.829a.457.457,0,0,0,0,.913h8.829a.457.457,0,0,0,0-.913Z",
    transform: "translate(-191.235 -215.903)",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.30ac438f.svg";
export { ForwardRef as ReactComponent };